import React from "react";
import styled from "styled-components";

const IconContainer = styled.div`
    width: 70px;
    height: 70px;
    background: white;
    color: black;

    &:hover {
        background: #f1f1f1;
    }

    img {
        width: 100%;
        height: 100%;
    }
`;

export default function Icon({ icon, style, baseUrl, onClick }) {
    const url = `${baseUrl}/${style.toLowerCase()}/${style.toLowerCase()}-${icon}.svg`;

    return (
        <IconContainer onClick={onClick}>
            <img src={url} />
        </IconContainer>
    );
}
